import { render, staticRenderFns } from "./cottage.vue?vue&type=template&id=43096a4a"
import script from "./cottage.vue?vue&type=script&lang=js"
export * from "./cottage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports